export { getCatalogPalette as getLibraryPalette } from '@/components/Catalog/catalogPalette';
